import { i18n } from "../plugins/i18n"

const { t } = i18n.global

export default {
    startsWith: 'Comienza por',
    contains: 'Contiene',
    notContains: 'No contiene',
    endsWith: 'Termina por',
    equals: 'Igual',
    notEquals: 'Distinto',
    noFilter: 'Sin filtro',
    lt: 'Menor que',
    lte: 'Menor o igual que',
    gt: 'Mayor que',
    gte: 'Mayor o igual que',
    dateIs: 'Fecha igual',
    dateIsNot: 'Fecha distinta',
    dateBefore: 'Fecha anterior',
    dateAfter: 'Fecha posterior',
    clear: 'Limpiar',
    apply: 'Aplicar',
    matchAll: 'Coincidir todo',
    matchAny: 'Coincidir cualquiera',
    addRule: 'Añadir regla',
    removeRule: 'Eliminar regla',
    accept: t('labels.yes'),
    reject: t('labels.no'),
    choose: t('labels.choose'),
    upload: t('labels.upload_file'),
    cancel: t('labels.cancel'),
    dayNames: [t('days_of_week.Domingo'), t('days_of_week.Lunes'), t('days_of_week.Martes'), t('days_of_week.Miércoles'), t('days_of_week.Jueves'), t('days_of_week.Viernes'), t('days_of_week.Sabado')],
    dayNamesShort: [t('days_of_week.Dom'), t('days_of_week.Lun'), t('days_of_week.Mar'), t('days_of_week.Mie'), t('days_of_week.Jue'), t('days_of_week.Vie'), t('days_of_week.Sab')],
    dayNamesMin: [t('days_of_week.D'), t('days_of_week.L'), t('days_of_week.M'), t('days_of_week.X'), t('days_of_week.J'), t('days_of_week.V'), t('days_of_week.S')],
    monthNames: [t('months.Enero'),t('months.Febrero'),t('months.Marzo'),t('months.Abril'),t('months.Mayo'),t('months.Junio'),t('months.Julio'),t('months.Agosto'),t('months.Septiembre'),t('months.Octubre'),t('months.Noviembre'),t('months.Diciembre')],
    monthNamesShort: [t('months.Ene'),t('months.Feb'),t('months.Mar'),t('months.Abr'),t('months.May'),t('months.Jun'),t('months.Jul'),t('months.Ago'),t('months.Sep'),t('months.Oct'),t('months.Nov'),t('months.Dic')],
    today: t('labels.today'),
    weekHeader: t('labels.week'),
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: t('labels.weak'),
    medium: t('labels.medium'),
    strong: t('labels.strong'),
    passwordPrompt: 'Introduce una contraseña',
    emptyFilterMessage: 'No se han encontrado resultados',
    emptyMessage: t('labels.no_options'),
    aria: {
        trueLabel: 'True',
        falseLabel: 'False',
        nullLabel: 'Not Selected',
        star: '1 estrella',
        stars: '{star} stars',
        selectAll: 'All items selected',
        unselectAll: 'All items unselected',
        close: 'Close',
        previous: 'Previous',
        next: 'Next',
        navigation: 'Navigation'
    }
}